import { useState } from 'react';
import apiClient from '../../../Services/ApiClient';
import useLoading from '../../Base/Hooks/useLoading';
import useApiClient from '../../Base/Hooks/useApiClient';
import useNotification from '../../../Hooks/useNotification.hook';

export default function useORSMCore({
	rootWorkplaceId,
}: {
	rootWorkplaceId: string;
}) {
	const [isSlugAvailable, setIsSlugAvailable] = useState(false);
	const { displayError } = useApiClient();
	const { showNotificationAlert } = useNotification();

	const {
		isLoading: isLoadingVerification,
		setIsLoading: setIsLoadingVerification,
	} = useLoading(false);

	const checkSlugAvailability = async (slug: string) => {
		setIsLoadingVerification(true);
		try {
			const response = await apiClient.post('/partner-calendar/slug-validate', {
				workplaceId: rootWorkplaceId,
				slug,
			});

			setIsSlugAvailable(response.status === 200);

			if (response.status !== 200 && response.data.message) {
				showNotificationAlert({
					content: response.data.message,
				});
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoadingVerification(false);
	};

	return {
		checkSlugAvailability,
		isSlugAvailable,
		setIsSlugAvailable,
		isLoadingVerification,
	};
}
